<template>
  <div class="login-page">
    <!-- 装饰光斑 -->
    <div class="decor-blur decor-left"></div>
    <div class="decor-blur decor-right"></div>

    <!-- 双栏卡片 -->
    <section class="login-card">
      <!-- 右侧表单栏 -->
      <div class="form-panel">
        <div class="form-back" @click="$router.back()">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="m12 19-7-7 7-7" />
            <path d="M19 12H5" />
          </svg>
          返回
        </div>
        <div class="logo-wrap">
          <img class="logo-img" src="/static/image/home/brand_logo.png" alt="关盈堂" />
          <div class="logo-text">
            <span class="logo-cn">关盈堂</span>
          </div>
        </div>


        <!-- 手机号 -->
        <div class="field">
          <div class="input-wrap" :class="{ 'input-error': !phone_status }">
            <span class="input-icon">
              <svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
            </span>
            <el-input placeholder="请输入手机号" v-model="phone" @blur="phoneOnBlur" maxlength="11"
              @keyup.enter.native="login" clearable autocomplete="off"></el-input>
          </div>
          <span class="span-hint" v-show="!phone_status">{{ phone_hint }}</span>
        </div>

        <!-- 验证码 -->
        <div class="field" v-show="login_type == 'verify'">
          <div class="input-row">
            <div class="input-wrap input-flex" :class="{ 'input-error': !verify_status }">
              <span class="input-icon">
                <svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
              </span>
              <el-input placeholder="输入验证码" v-model="verify_code" @blur="verifyOnBlur" maxlength="11"
                @keyup.enter.native="login" clearable></el-input>
            </div>
            <el-button class="btn-verify" @click="getVerifyCode" type="primary" :loading="vloading"
              :disabled="verify_disable">{{ btn_verify }}</el-button>
          </div>
          <span class="span-hint" v-show="!verify_status">{{ verify_hint }}</span>

        </div>

        <!-- 密码 -->
        <div class="field" v-show="login_type == 'password'">
          <div class="input-wrap" :class="{ 'input-error': !password_status }">
            <span class="input-icon">
              <svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </svg>
            </span>
            <el-input placeholder="请输入密码" v-model="password" @blur="passwordOnBlur" @keyup.enter.native="login"
              minlength="6" show-password></el-input>
          </div>
          <span class="span-hint" v-show="!password_status">{{ password_hint }}</span>

        </div>
        <div class="form-switch-row">
          <span class="link-switch" @click="loginChangeClick">{{ login_change_text }}</span>
        </div>
        <!-- 协议 + 切换 -->
        <div class="form-extras">
          <el-checkbox v-model="checked" class="agree-checkbox">
            <span class="agree-text">
              同意
              <a class="agree-link" @click.stop="toProtocol">《关盈堂最终用户许可协议》</a>
            </span>
          </el-checkbox>
        </div>
        

        <!-- 登录按钮 -->
        <el-button class="btn-confirm" type="primary" :loading="loading" @click="login">{{ confirm_text }}</el-button>
      </div>
    </section>
  </div>
</template>
<script>
import utils from "@/js/utils.js";
export default {
  data() {
    return {
      // checked: true,
      phone_hint: "请输入手机号",
      phone_status: true,
      phone: "",
      verify_hint: "请输入验证码",
      verify_status: true,
      verify_code: "",
      password_hint: "请输入密码",
      password_status: true,
      password: "",
      btn_verify: "获取验证码",
      verify_disable: false,
      verify_second: 60,
      confirm_text: "登 录",
      login_change_text: "忘记密码？",
      login_type: "password", //verify or password
      loading: false,
      checked: false,
      vloading: false,
    };
  },
  created() {
    var args = utils.getRequest(location.href);
    if (args.hasOwnProperty("code") && !this.utils.isEmptyStr(args.code)) {
      console.log(args.code);
      var params = {
        wxCode: args.code,
        type: "pc",
      };
      this.wjtHttp.post(
        this,
        "/api/wechat/v1/login",
        params,
        false,
        (res) => {
          this.vloading = false;
          var data = res.data;
          if (data.code == 200) {
            if (!this.utils.isEmptyStr(data.token)) {
              this.$cookies.set("token", data.token, { expires: 1 });
              this.wjtHttp.get(
                this,
                "/api/getInfo",
                {},
                false,
                (res) => {
                  this.loading = false;
                  var infoData = res.data;
                  if (infoData.code == 200) {
                    this.$store.commit("updateUserInfo", infoData);
                    if (data.pwdNotSet == false) {
                      this.$router.replace("/SetPassword");
                    } else {
                      this.$message({
                        message: "登录成功",
                        type: "success",
                      });
                      this.$router.replace("/");
                    }
                  } else {
                    this.$message({
                      message:
                        infoData.msg && infoData.msg.length > 0
                          ? infoData.msg
                          : "服务异常，请联系管理员",
                      type: "error",
                    });
                  }
                },
                (err) => {
                  this.loading = false;
                }
              );
            } else {
              //绑定手机号
              this.$message({
                message: "首次登录请绑定手机号码",
                type: "info",
              });
              this.$router.replace({
                path: "/Bind",
                query: {
                  code: args.code,
                },
              });
            }
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0
                  ? data.msg
                  : "服务异常，请联系管理员",
              type: "error",
            });
          }
        },
        (err) => {
          this.vloading = false;
        }
      );
    }
  },
  methods: {
    toProtocol() {
      this.$router.push("/protocol");
    },

    jumpAboutUsers() {
      this.$router.push({ path: "/AboutUsers" });
    },

    getVerifyCode() {
      if (this.phone.length == 0) {
        this.$message({
          message: "请先填写手机号",
          type: "fail",
        });
        return;
      }
      if (this.phone.length < 11) {
        this.$message({
          message: "请先填写正确的手机号",
          type: "fail",
        });
        return;
      }
      var codeParams = {
        telephone: this.phone,
        phoneMd5: this.$md5(this.phone),
        type: "login",
      };
      this.vloading = true;
      this.wjtHttp.get(
        this,
        "/api/smsCode",
        codeParams,
        false,
        (res) => {
          this.vloading = false;
          var data = res.data;
          if (data.code == 200) {
            this.$message({
              message: "发送成功",
              type: "success",
            });
            this.verify_disable = true;
            clearInterval(this.mInterval);
            this.mInterval = setInterval(() => {
              if (this.verify_second == 0) {
                this.verify_disable = false;
                this.verify_second = 60;
                clearInterval(this.mInterval);
                return;
              }
              this.verify_second--;
            }, 1000);
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0
                  ? data.msg
                  : "服务异常，请联系管理员",
              type: "error",
            });
          }
        },
        (err) => {
          this.vloading = false;
        }
      );
    },
    phoneOnBlur() {
      if (this.phone.length == 0) {
        this.phone_status = false;
        this.phone_hint = "请输入手机号码";
      } else if (this.phone.length < 11 || this.phone.length > 11) {
        this.phone_status = false;
        this.phone_hint = "请输入正确的手机号码";
      } else {
        this.phone_status = true;
      }
    },
    verifyOnBlur() {
      if (this.verify_code.length == 0) {
        this.verify_status = false;
        this.verify_hint = "请输入验证码";
      } else {
        this.verify_status = true;
      }
    },
    passwordOnBlur() {
      if (this.password.length == 0) {
        this.password_status = false;
        this.password_hint = "请输入密码";
      } else if (this.password.length < 6) {
        this.password_status = false;
        this.password_hint = "密码必须大于六位";
      } else {
        this.password_status = true;
      }
    },
    loginChangeClick() {
      if (this.login_type == "verify") {
        this.login_type = "password";
      } else {
        //忘记密码
        this.$router.push("/ResetPassword");
      }
    },
    verifyLoginClick() {
      this.login_type = "verify";
    },
    toSignup() {
      this.$router.push("/Signup");
    },
    wxLogin() {
      console.log(process.env.APP_ID);
      console.log(process.env.DOMAIN_URL);
      location.href =
        "https://open.weixin.qq.com/connect/qrconnect?appid=" +
        process.env.APP_ID +
        "&redirect_uri=" +
        process.env.DOMAIN_URL +
        "/Login&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect";
    },
    login() {
      if (!this.checked) {
        this.$message({
          message: "请阅读并同意《关盈堂最终用户许可协议》",
          type: "error",
        });
        return;
      }
      if (this.phone.length == 0) {
        this.phone_status = false;
        this.phone_hint = "请输入手机号码";
        return;
      }
      if (this.phone.length < 11 || this.phone.length > 11) {
        this.phone_status = false;
        this.phone_hint = "请输入正确的手机号码";
        return;
      }
      if (this.login_type == "verify") {
        if (this.verify_code.length == 0) {
          this.verify_status = false;
          this.verify_hint = "请输入验证码";
          return;
        }
        var vParams = {
          code: this.verify_code,
          username: this.phone,
          phoneMd5: this.$md5(this.phone),
          type: "sms",
        };
        this.loading = true;
        this.wjtHttp.post(
          this,
          "/api/login",
          vParams,
          false,
          (res) => {
            var data = res.data;
            if (data.code == 200) {
              this.$cookies.set("token", data.token, { expires: 1 });
              this.wjtHttp.get(
                this,
                "/api/getInfo",
                {},
                false,
                (res) => {
                  this.loading = false;
                  var infoData = res.data;
                  if (infoData.code == 200) {
                    this.$store.commit("updateUserInfo", infoData);
                    if (data.pwdNotSet == false) {
                      this.$router.replace("/SetPassword");
                    } else {
                      this.$message({
                        message: "登录成功",
                        type: "success",
                      });
                      this.$router.replace("/");
                    }
                  } else {
                    this.$message({
                      message:
                        infoData.msg && infoData.msg.length > 0
                          ? infoData.msg
                          : "服务异常，请联系管理员",
                      type: "error",
                    });
                  }
                },
                (err) => {
                  this.loading = false;
                }
              );
            } else {
              this.loading = false;
              this.$message({
                message:
                  data.msg && data.msg.length > 0
                    ? data.msg
                    : "服务异常，请联系管理员",
                type: "error",
              });
            }
          },
          (err) => {
            this.loading = false;
          }
        );
      } else {
        if (this.password.length == 0) {
          this.password_status = false;
          this.password_hint = "请输入密码";
          return;
        }
        if (this.password.length < 6) {
          this.password_status = false;
          this.password_hint = "密码必须大于六位";
          return;
        }
        var pParams = {
          password: this.password,
          username: this.phone,
          phoneMd5: this.$md5(this.phone),
          type: "pwd",
        };
        this.loading = true;
        this.wjtHttp.post(
          this,
          "/api/login",
          pParams,
          false,
          (res) => {
            var data = res.data;
            if (data.code == 200) {
              this.$cookies.set("token", data.token, { expires: 1 });
              this.wjtHttp.get(
                this,
                "/api/getInfo",
                {},
                false,
                (res) => {
                  this.loading = false;
                  var data = res.data;
                  if (data.code == 200) {
                    this.$message({
                      message: "登录成功",
                      type: "success",
                    });
                    this.$store.commit("updateUserInfo", data);
                    this.$router.replace("/");
                  } else {
                    this.$message({
                      message:
                        data.msg && data.msg.length > 0
                          ? data.msg
                          : "服务异常，请联系管理员",
                      type: "error",
                    });
                  }
                },
                (err) => {
                  this.loading = false;
                }
              );
            } else {
              this.loading = false;
              this.$message({
                message:
                  data.msg && data.msg.length > 0
                    ? data.msg
                    : "服务异常，请联系管理员",
                type: "error",
              });
            }
          },
          (err) => {
            this.loading = false;
          }
        );
      }
    },
  },
  watch: {
    verify_disable: function (val) {
      if (val) {
        this.btn_verify = this.verify_second + "后重发";
      } else {
        this.btn_verify = "获取验证码";
      }
    },
    verify_second: function (val) {
      if (val < 60) {
        this.btn_verify = val + "后重发";
      }
    },
    login_type: function (val) {
      if (val == "verify") {
        this.login_change_text = "密码登录";
      } else {
        this.login_change_text = "忘记密码？";
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fromPath = from.path;
    });
  },
};
</script>
<style scoped>
/* ===== 覆盖全局 element-ui / App.vue 强制样式（scoped 下用 !important 穿透） ===== */
.login-page>>>.el-input__inner {
  font-size: 18px !important;
  height: 56px !important;
  line-height: 56px !important;
  padding: 0 0 0 0 !important;
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
  -webkit-box-shadow: 0 0 0 1000px transparent inset !important;
  color: #1a1a1a !important;
  -webkit-text-fill-color: #1a1a1a !important;
}

.login-page>>>.el-input__inner::placeholder {
  color: #a7b8b4 !important;
}

.login-page>>>.el-input__inner:-webkit-autofill,
.login-page>>>.el-input__inner:-webkit-autofill:hover,
.login-page>>>.el-input__inner:-webkit-autofill:focus,
.login-page>>>.el-input__inner:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 1000px transparent inset !important;
  box-shadow: 0 0 0 1000px transparent inset !important;
  -webkit-text-fill-color: #1a1a1a !important;
  transition: background-color 5000s ease-in-out 0s !important;
}

.login-page>>>.el-input {
  width: 100%;
  font-size: 15px;
}

.login-page>>>.el-input__prefix,
.login-page>>>.el-input__suffix {
  display: none;
}

.login-page>>>.el-input .el-input__clear {
  color: #7f9994;
  font-size: 14px;
}

.login-page>>>.el-form-item__label,
.login-page>>>.el-form-item__content {
  font-size: inherit !important;
  line-height: inherit !important;
  height: auto !important;
  display: block !important;
  margin: 0 !important;
  padding: 0 !important;
}

.login-page button,
.login-page .btn-verify,
.login-page .btn-confirm {
  font-size: 16px !important;
  font-family: inherit !important;
}

.login-page .btn-confirm {
  font-size: 16px !important;
  font-weight: 600 !important;
}

.login-page .btn-verify {
  font-size: 14px !important;
  font-weight: 500 !important;
}

/* ===== 页面容器 ===== */
.login-page {
  position: relative;
  /* 让 min-height 把 padding 包含在内，避免 100vh + 上下 padding 撑出滚动条 */
  box-sizing: border-box;
  min-height: 100vh;
  background: #f3f9f8;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 40px 16px;
  font-family: '思源黑体', 'Source Han Sans SC', 'Noto Sans SC', system-ui, sans-serif;
}

/* ===== 装饰光斑 ===== */
.decor-blur {
  position: absolute;
  border-radius: 50%;
  filter: blur(70px);
  pointer-events: none;
  z-index: 0;
}

.decor-left {
  left: -96px;
  top: 80px;
  width: 288px;
  height: 288px;
  background: rgba(0, 151, 152, 0.1);
}

.decor-right {
  right: 40px;
  bottom: 40px;
  width: 320px;
  height: 320px;
  background: rgba(200, 169, 110, 0.12);
}

/* ===== 卡片 ===== */
.login-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 660px;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid #d3e6e3;
  border-radius: 32px;
  overflow: hidden;
  box-shadow: 0 24px 80px rgba(23, 61, 59, 0.16);
  backdrop-filter: blur(10px);
  box-sizing: border-box;
}

/* ===== 右侧表单栏 ===== */
.form-panel {
  padding: 40px 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 490px;
  margin: 0 auto;
  box-sizing: border-box;
}

.form-panel>.form-header,
.form-panel>.field,
.form-panel>.form-extras,
.form-panel>.form-switch-row,
.form-panel>.btn-confirm {
  align-self: stretch;
}

.form-back {
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 999px;
  border: 1px solid rgba(0, 151, 152, 0.2);
  background: #f3f9f8;
  font-size: 13px;
  font-weight: 500;
  color: #009798;
  cursor: pointer;
  transition: background 0.2s;
}

.form-back:hover {
  background: #e3f3f1;
}

.form-header {
  margin-bottom: 32px;
  text-align: center;
}

.header-icon-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #eaf6f4;
  color: #009798;
  margin-bottom: 16px;
}

.form-title {
  font-size: 30px;
  font-weight: 700;
  color: #304744;
  margin: 0;
}

.form-subtitle {
  margin-top: 8px;
  font-size: 14px;
  color: #527f77;
}

/* ===== 表单字段 ===== */
.field {
  margin-bottom: 8px;
}

.field-label {
  display: block;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #304744;
}

.span-hint {
  display: block;
  font-size: 16px;
  color: #e6502e;
  margin-bottom: 6px;
}

.input-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 56px;
  padding: 0 16px;
  border-radius: 16px;
  border: 1px solid #d3e6e3;
  background: #fbfdfd;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.input-wrap:focus-within {
  border-color: #009798;
  box-shadow: 0 0 0 4px rgba(0, 151, 152, 0.1);
}

.input-wrap.input-error {
  border-color: #e6502e;
}

.input-icon {
  display: flex;
  align-items: center;
  color: #7f9994;
  flex-shrink: 0;
}

.input-flex {
  flex: 1;
}

.input-row {
  display: flex;
  gap: 12px;
}

.input-row .input-wrap {
  flex: 1;
}

/* ===== 覆盖 Element UI（局部补充） ===== */
.input-wrap>>>.el-input {
  width: 100%;
}

.input-wrap>>>.el-input__clear {
  color: #7f9994;
  font-size: 14px;
}

/* ===== 验证码按钮 ===== */
.btn-verify {
  height: 56px;
  border-radius: 16px;
  background: #009798 !important;
  border-color: #009798 !important;
  padding: 0 18px;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}

.btn-verify:hover {
  background: #007e7f !important;
  border-color: #007e7f !important;
}

.btn-verify.is-disabled,
.btn-verify.is-disabled:hover {
  background: #9fd0ce;
  border-color: #9fd0ce;
  color: #fff;
}

/* ===== 协议 + 切换 ===== */
.form-extras {
  display: flex;
  align-items: flex-start;
  margin: 0px 0 18px;
}

.form-switch-row {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.agree-checkbox {
  flex: 1;
  min-width: 0;
  align-items: flex-start;
  width: 100%;
  white-space: normal;
  display: block;
  margin: 0;
}

.agree-checkbox>>>.el-checkbox {
  white-space: normal !important;
  display: inline-flex !important;
  align-items: flex-start !important;
  width: 100% !important;
  margin: 0 !important;
  line-height: 1.7 !important;
  color: #527f77 !important;
  font-size: 12px !important;
  font-weight: 500 !important;
}

.agree-checkbox>>>.el-checkbox__input {
  position: static !important;
  flex-shrink: 0;
  margin-top: 5px !important;
  display: inline-block !important;
  width: auto !important;
  height: auto !important;
  line-height: 1 !important;
  top: auto !important;
  left: auto !important;
  right: auto !important;
  bottom: auto !important;
}

.agree-checkbox>>>.el-checkbox__label {
  font-size: 16px !important;
  color: #527f77 !important;
  line-height: 1.7 !important;
  padding-left: 8px !important;
  white-space: normal !important;
  word-break: break-word !important;
  display: inline !important;
  vertical-align: top !important;
  width: auto !important;
  flex: 1 1 auto;
  min-width: 0;
  box-sizing: border-box !important;
  text-overflow: clip !important;
  overflow: visible !important;

}

.agree-checkbox>>>.el-checkbox__original {
  display: none;
}

.agree-checkbox>>>.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #009798;
  border-color: #009798;
}

.agree-checkbox>>>.el-checkbox__input.is-checked+.el-checkbox__label {
  color: #304744;
}

.agree-checkbox>>>.el-checkbox__inner {
  border-radius: 4px;
    border: 1px solid #009798;
}

.agree-checkbox>>>.el-checkbox__inner:hover {
  border-color: #009798;
}

.agree-text {
  display: inline;
  color: #527f77;
  word-break: break-word;
}

.agree-text a {
  color: #009798;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
}

.agree-text a:hover {
  text-decoration: underline;
}

.link-switch {
  font-size: 16px;
  font-weight: 500;
  color: #009798;
  cursor: pointer;
  white-space: nowrap;
  padding-top: 2px;
}

.link-switch:hover {
  text-decoration: underline;
}

/* ===== 登录按钮 ===== */
.btn-confirm {
  width: 100%;
  height: 56px;
  border-radius: 16px;
  background: #009798 !important;
  border-color: #009798 !important;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  box-shadow: 0 12px 24px rgba(0, 151, 152, 0.2);
  transition: background 0.2s, box-shadow 0.2s;
}

.btn-confirm:hover {
  background: #007e7f !important;
  border-color: #007e7f !important;
  box-shadow: 0 16px 32px rgba(0, 151, 152, 0.28);
}

/* ===== 响应式：移动端 ===== */
@media (max-width: 768px) {
  .login-page {
    padding: 0;
    align-items: stretch;
    min-height: 100vh;
  }

  .login-card {
    grid-template-columns: 1fr;
    border-radius: 0;
    max-width: 100%;
    width: 100%;
    min-height: 100vh;
    margin-top: 0;
    box-shadow: none;
    border: none;
    background: #fff;
  }

  .form-panel {
    padding: 20px 18px 28px;
    width: 100%;
    flex: 1;
    max-width: 100%;
  }

  .form-back {
    top: 12px;
    left: 12px;
    padding: 6px 14px;
    font-size: 12px;
  }

  .form-header {
    margin-bottom: 20px;
    text-align: left;
  }

  .header-icon-circle {
    margin: 0 0 12px;
    width: 52px;
    height: 52px;
  }

  .header-icon-circle svg {
    width: 26px;
    height: 26px;
  }

  .form-title {
    font-size: 24px;
  }

  .form-subtitle {
    font-size: 13px;
    margin-top: 6px;
  }

  .field {
    margin-bottom: 4px;
  }

  .field-label {
    font-size: 12px;
    margin-bottom: 6px;
  }

  .input-wrap {
    height: 48px;
    padding: 0 12px;
    border-radius: 14px;
    gap: 8px;
  }

  .input-wrap>>>.el-input {
    width: 100%;
  }

  .input-wrap>>>.el-input__inner {
    height: 48px;
    line-height: 48px;
    font-size: 15px;
    padding: 0;
    -webkit-box-shadow: 0 0 0 1000px transparent inset !important;
    box-shadow: 0 0 0 1000px transparent inset !important;
    -webkit-text-fill-color: #1a1a1a;
    background-color: transparent !important;
  }

  .input-wrap>>>.el-input__inner:-webkit-autofill,
  .input-wrap>>>.el-input__inner:-webkit-autofill:hover,
  .input-wrap>>>.el-input__inner:-webkit-autofill:focus,
  .input-wrap>>>.el-input__inner:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px transparent inset !important;
    box-shadow: 0 0 0 1000px transparent inset !important;
    -webkit-text-fill-color: #1a1a1a !important;
    transition: background-color 5000s ease-in-out 0s;
  }

  .input-icon svg {
    width: 17px;
    height: 17px;
  }

  .input-row {
    gap: 8px;
  }

  .btn-verify {
    height: 48px;
    padding: 0 12px;
    font-size: 12px;
    border-radius: 14px;
  }

  .btn-confirm {
    height: 48px;
    font-size: 15px;
    border-radius: 14px;
  }

  .form-extras {
    margin: 14px 0 6px;
  }

  .form-switch-row {
    margin-bottom: 18px;
  }

  .agree-checkbox>>>.el-checkbox__label {
    font-size: 11px;
    line-height: 1.6;
  }

  .agree-checkbox>>>.el-checkbox__input {
    margin-top: 1px;
  }

  .link-switch {
    font-size: 12px;
  }

  .decor-blur {
    display: none;
  }
}

/* ===== 平板过渡 ===== */
@media (min-width: 769px) and (max-width: 960px) {
  .login-card {
    grid-template-columns: minmax(0, 1fr);
  }

  .form-panel {
    padding: 32px 28px;
  }
}

/* ── Logo ── */
.logo-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  flex-shrink: 0;
  padding: 50px 0;
}

.logo-img {
  width: 84px;
  height: 84px;
  object-fit: contain;
  display: block;
  flex-shrink: 0;
}

.logo-text {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.logo-cn {
  font-size: 24px;
  font-weight: bold;
  color: #304744;
  letter-spacing: 1px;
}


</style>
